import Vue from 'vue'
import configs from '@/config'

let resource = null

export const actions = {
  sendFeatureRequest: {
    method: 'POST',
    url: `${configs.baseUrl}/api/enterprise-Inquiry/team-settings-feature-request`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sendFeatureRequest = async (requestData) => {
  const res = await resource.sendFeatureRequest(requestData)
  return res.body
}

export default {
  initResource,
  sendFeatureRequest,
}
